// src/bobs/components/details/recentRecipientsMenu.tsx
import { FC, memo } from "react";
import { Menu, ActionIcon, Button } from "@mantine/core";
import { IconHistory } from "@tabler/icons-react";
import { PayAttempt } from "../../stores/PayAttempt";
import React from "react";

interface Props {
  recentAddresses: string[];
  payAttempt: PayAttempt;
}

const RecentRecipientsMenu: FC<Props> = ({ recentAddresses, payAttempt }) => {
  const hidden =
    payAttempt.userEnteredPaymentString.trim().length > 0 ||
    recentAddresses.length === 0;

  if (hidden) return null;

  return (
    <Menu shadow="md" width={240}>
      <Menu.Target>
        <Button
          variant="filled"
          color="blue"
          aria-label="Recent recipients"
          leftSection={<IconHistory size={16} />}
        >
          Recent Recipients
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Recent recipients</Menu.Label>
        {recentAddresses.map((addr) => (
          <Menu.Item
            key={addr}
            onClick={() => payAttempt.setUserEnteredPaymentString(addr)}
            style={{ whiteSpace: "normal", wordBreak: "break-all" }}
          >
            {addr}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default memo(RecentRecipientsMenu);
